import { exec, ExecOutputReturnValue } from "shelljs";
import treeKill from "tree-kill";

import { ILogger } from "../../Commons/Logging/ILogger";

import { ShellProcessHandle } from "./ShellProcessHandle";

export class ProcessUtils {
    public static createShellProcess(command: string, args?: string[], workingDirectory?: string): ShellProcessHandle {
        if (command == "npm" && process.platform === "linux") {
            return new ShellProcessHandle({
                args: [command, ...(args ?? [])],
                command: "unbuffer",
                workingDirectory: workingDirectory,
            });
        }
        return new ShellProcessHandle({
            args: args || [],
            command: command,
            workingDirectory: workingDirectory,
        });
    }

    public static killTreeAsync(pid: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            treeKill(pid, "SIGKILL", err => {
                if (err) {
                    reject(err);
                } else {
                    resolve();
                }
            });
        });
    }

    public static execShellCommand(
        command: string,
        args: string[],
        workingDirectory: string,
        logger: ILogger
    ): Promise<ExecOutputReturnValue> {
        return new Promise<ExecOutputReturnValue>((resolve, reject) => {
            logger.verbose(`Run: ${command}`);
            exec(
                [command, ...args].join(" "),
                { cwd: workingDirectory, async: true, silent: true },
                (code, stdout, stderr) => {
                    for (const line of stdout.split("\n")) {
                        logger.verbose(line);
                    }

                    for (const line of stderr.split("\n")) {
                        logger.verbose(line);
                    }

                    if (code !== 0) {
                        reject(new Error(`Executed with exit code ${code}`));
                    }
                    resolve({
                        code: 0,
                        stdout: stdout,
                        stderr: stderr,
                    });
                }
            );
        });
    }
}
